<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Grievance Reddressal Committee</h1>
      <ul>
        <li><a class="active" routerLink="/home">Home</a></li>
        <li>Grievance Reddressal Committee</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 committee-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <div class="widget-area">
            <div class="widget-archives footer-widget mb-50">
              <h3 class="widget-title">Committees</h3>
              <ul>
                <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                  <ul class="sub-menu">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/anti-ragging-committee">Anti Ragging Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/grievance-reddressal-committee">Grievance Reddressal Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-complaints-committee">Internal Complaints Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/sc-and-st-grievance-committee">SC &amp; ST Grievance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-quality-assurance-committee">Internal Quality Assurance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/institution-industry-cell">Institution Industry Cell</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="committee-content-wrap">
            <h2 class="committee-main-title">Grievance Reddressal Committee</h2>

            <p class="committee-paragraph">
              As per the rules and regulations addressed by the AICTE / UGC / SPPU, for student or other stake holders
              in a Institution, “Ombudsman” &amp; “Grievance Reddressal Committee” of PVKK Degree & P.G College, Near RTC Bus Stand, Khaja Nagar, Anantapuramu, has been constituted with following Staff in different
              positions to enquire the nature and extent of grievance.
            </p>

            <h3 class="committee-sub-title">Ombudsman: - Dr. T. SREENIVASA REDDY</h3>

            <p class="blog-table-wrap">
              <a href="/assets/college/Committees/GrievanceReddressalCommittee2024-25.pdf" target="_blank">Grievance Reddressal Committee (click to view)</a>
            </p>

            <h3 class="committee-sub-title">The Committee formed will deal with the complaints as listed below</h3>

            <ol class="complaint-list  listing-style">
              <li>Any admission contrary to merit determined in accordance with the declared admission policy of the College.</li>
              <li>Irregularity in the admission process adopted by the College.</li>
              <li>Refusing admission in accordance with the declared admission policy of the College.</li>
              <li>Non-publication of prospectus, as specified.</li>
              <li>Publishing any information in the prospectus, which is false or misleading and not based on facts.</li>
              <li>Withholding or refusing to return any document in the form of certificates of PG, degree, diploma or any other award or other document deposited with it by a person for the purpose of seeking admission in the College, with a view to induce or compel such person to pay any fee or fees in respect of any course or program of study which such person does not intend to pursue.</li>
              <li>Withholding or refusing to return any document in the form of certificates of PG, degree, diploma or any other award or other document deposited with it by a person for the purpose of seeking admission in the College, with a view to induce or compel such person to pay any fee or fees in respect of any course or program of study which such person does not intend to pursue.</li>
              <li>Demand of money in excess of that specified in the declared admission policy or approved by the competent authority to be charged by College.</li>
              <li>Breach of the policy for reservation in admission as may be applicable.</li>
              <li>Complaints, of alleged discrimination of students, from the Scheduled Castes, the Scheduled Tribes, Other Backward Classes, Women, Minority or Disabled categories.</li>
              <li>Delay in conduct of examinations or declaration of results beyond that specified in the academic calendar.</li>
              <li>On provision of student amenities as may have been promised or required to be provided by the College.</li>
              <li>Denial of quality education as promised at the time of admission or required to be provided.</li>
              <li>Non-transparent or unfair evaluation practices.</li>
              <li>Harassment and victimization of students, including sexual harassment.</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

